import 'arrive';
import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

gsap.registerPlugin(ScrollTrigger);

// Inizializza Lenis
const lenis = new Lenis({
  // puoi passare anche config extra tipo duration, smoothWheel ecc.
  lerp: 0.1, // controllo della fluidità (0 -> nessuna inerzia, 1 -> fermo)
  prevent: (node) => node.closest('.no-lenis')
});

window.lenis = lenis; // 👈 Questo lo rende accessibile ovunque senza import

// Collegamento Lenis ↔ GSAP
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // ticker usa secondi, Lenis vuole ms
  ScrollTrigger.update(); // aggiorna ScrollTrigger
});

// Quando il DOM cambia (es. aggiunta di blocchi ACF), forza l'aggiornamento di ScrollTrigger.
// Usiamo un timeout per assicurarci che il nuovo contenuto sia stato renderizzato.
document.body.arrive('*', function() {
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 200); // 200ms è un ritardo di sicurezza, puoi provare a ridurlo
});

// Disabilita smoothing GSAP per sincronizzazione più precisa
gsap.ticker.lagSmoothing(0);



// applico classi sul body in base al contenuto che trovo sul DOM
function applyBlockCardsCtaClass() {
  if (
    document.body.classList.contains('has-block-cards-cta') ||
    !document.querySelector('.block-cards-cta__grid-mobile')
  ) {
    return;
  }

  document.body.classList.add('has-free-carousel-mobile');
}

// esegui subito
applyBlockCardsCtaClass();

// Gestione scroll interno .vc-stations-list su mobile (pagina Trova Stazioni)
const scrollContainer = document.querySelector('.vc-stations-list');
if (scrollContainer) {
  const getLimits = () => {
    const scrollTop    = scrollContainer.scrollTop;
    const scrollHeight = scrollContainer.scrollHeight;
    const clientHeight = scrollContainer.clientHeight;
    return {
      isAtBottom: scrollTop + clientHeight >= scrollHeight - 1,
      isAtTop:    scrollTop <= 0,
    };
  };

  // Aggiorna l'attributo mentre l'utente scrolla dentro il contenitore
  scrollContainer.addEventListener('scroll', () => {
    const { isAtBottom, isAtTop } = getLimits();
    if (isAtBottom || isAtTop) {
      scrollContainer.removeAttribute('data-lenis-prevent');
    } else {
      scrollContainer.setAttribute('data-lenis-prevent', '');
    }
  }, { passive: true });

  // Quando Lenis ha preso il controllo (attributo assente) e l'utente
  // ruota la rotella verso il contenuto interno, ri-applica l'attributo
  // prima che Lenis possa intercettare lo scroll
  scrollContainer.addEventListener('wheel', (e) => {
    const { isAtBottom, isAtTop } = getLimits();
    const scrollingUp   = e.deltaY < 0;
    const scrollingDown = e.deltaY > 0;

    if ((isAtBottom && scrollingUp) || (isAtTop && scrollingDown)) {
      scrollContainer.setAttribute('data-lenis-prevent', '');
    }
  }, { passive: true });
}

//
//  Carosello Lannding page
//
document.arrive('.block-landing-text-image', {existing: true}, function(){
    const swiper = new Swiper('.landing-carousel', {
        loop: false,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        slidesPerView: 'auto',
        // autoplay: {
        //     delay: 4000,
        //     disableOnInteraction: false,
        // },
        centeredSlides: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });
});